import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useLang } from "@/contexts/LangContext";

export default function Categories() {
  const { t, lang } = useLang();
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);

  return (
    <div data-testid="categories-page" className="px-6 lg:px-16 py-16 max-w-[1440px] mx-auto">
      <p className="text-xs uppercase tracking-[0.3em] text-[#C8A96A] mb-3">{lang === "tr" ? "Koleksiyonlar" : "Collections"}</p>
      <h1 className="font-heading text-4xl lg:text-5xl mb-12">{t("nav.categories")}</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-6 lg:gap-10">
        {cats.map((c) => (
          <Link key={c.id} to={`/products?category=${c.id}`} data-testid={`cat-link-${c.slug}`} className="group relative overflow-hidden aspect-[4/5] block">
            <img src={c.image_url} alt={c.name_tr} loading="lazy"
              className="w-full h-full object-cover transition-transform duration-[1500ms] ease-out group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <h2 className="font-heading text-2xl text-white">{lang === "tr" ? c.name_tr : c.name_en}</h2>
              <span className="text-xs uppercase tracking-[0.2em] text-white/80">{lang === "tr" ? "Keşfet" : "Discover"} →</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
